// extracted by mini-css-extract-plugin
export default {"wrapper":"orderBy_wrapper__Na6GP","iconWrapper":"orderBy_iconWrapper__vkYr1","sortIconDesc":"orderBy_sortIconDesc__YN6EE","sortIconAsc":"orderBy_sortIconAsc__UIbRL"};